let loggedIn = (typeof PageMetadata == 'object' && PageMetadata.userSegVars.gd.trim() != '' && PageMetadata.userSegVars.gd != '0');

const likeApiBaseUri = '//www.' + (document.domain.match(/qa(\d+)?\./) != null ? 'qa01.' : document.domain.match(/(staging\.)/) != null ? 'staging.' : '') + 'medscape' + (document.domain.indexOf('.org') != -1 ? '.org' : '.com') + '/api/v1/contentfeedback/article_like';

function addLikeIcon() {
	if (typeof likesConfig == 'object') {		
		if (typeof likesConfig.iconsToAppend != 'undefined' && typeof likesConfig.iconsToAppend.length != 'undefined') {			
			likesConfig.iconsToAppend.forEach(function(icon) {
				let parentElem = document.querySelector(icon[0]);
				if (parentElem != null) {					
					if (parentElem.querySelector('.like') == null) {
						let iconElem = document.createElement(icon[1]);
						iconElem.className = 'like';
						iconElem.innerHTML = '<span class="like-count"></span>';
						if (parentElem.querySelector('.comment-count') != null) {
							parentElem.insertBefore(iconElem,parentElem.childNodes[1]);
						} else {
							parentElem.insertBefore(iconElem,parentElem.childNodes[0]);
						}
					}
					parentElem.querySelector('.like').removeEventListener('click', likeHandler);
					parentElem.querySelector('.like').addEventListener('click', likeHandler);
				}
			});
		}
	}
	fetchLikes();	
}

function cleanLikeUrl() {		
	let hostname = location.hostname;
	let contentUri = location.pathname.split('_')[0];
	if (hostname.indexOf('emedicine') != -1) {		
		contentUri = contentUri.replace(/(\/\d+)[^\d].+/,'$1');
	}
	if (contentUri.indexOf('/drug/formulary') != -1) {
		contentUri = contentUri.replace('/drug/formulary','/drug');
	}
	contentUri = contentUri.replace(/^\/s\//,'/');
	return contentUri;
}

function fetchLikes() {
	fetch(likeApiBaseUri + '/get_like_data', {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				like_requests: [{
					hostName: location.hostname,
					contentUri: cleanLikeUrl(),
				}],
			})
		})
		.then(function(response) {
			return response.json();
		})
		.then(function(data) {
			updateLikeCount(data[0]);
		})
		.catch(function(error) {
			console.error('Error: ', error);
		});
}

function updateLikeCount(data) {	
	let likeCount = data.likeCount ? data.likeCount : '';
	likesConfig.iconsToAppend.forEach(function(icon) {
		let parentElem = document.querySelector(icon[0]);
		let likeElem = parentElem.querySelector('.like');
		parentElem.querySelector('.like-count').innerHTML = likeCount;
		if (data.interactionType) {
			likeElem.classList.add('liked');
		} else {
			likeElem.classList.remove('liked');
		}
		if (!loggedIn && likeCount > 0) {
			likeElem.classList.add('active');
		}
	});
}

function likeHandler() {
	var self = this;
	self.removeEventListener('click', likeHandler);
	if (loggedIn) {
		fetch(likeApiBaseUri + '/handle_on_like', {
				method: 'POST',
				mode: 'cors',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					like_requests: {
						hostName: location.hostname,
						contentUri: cleanLikeUrl()
					}
				})
			})
			.then(function(response) {
				return response.json();
			})
			.then(function(data) {
				var trackingText = likesConfig.trackVal + '_like';
				if (data.interactionType === 0) {
					trackingText = likesConfig.trackVal + '_unlike';
				}
				wmdPageLink(trackingText);
				updateLikeCount(data);
				self.addEventListener('click', likeHandler);
			})
			.catch(function(error) {
				console.error('Error: ', error);
			});
	}
}

window.fetchLikes = function () {
	fetchLikes();
}
addLikeIcon();